export const BRAND = {
    primary: "#2a93b1",
    success: "#16A34A",
    warning: "#F59E0B",
    danger: "#EF4444",
    white: "#ffffff",
    gray100: "#f5f5f5",
    gray200: "#e3e5e8",
};

export const RADIUS = 7;
export const HEADER_HEIGHT = 60;

// Можно хранить размеры, отступы, шрифты
export const TYPOGRAPHY = {
    fontFamily: `'Inter', system-ui, -apple-system, Segoe UI, Roboto, sans-serif`,
};

import type { ThemeConfig } from "antd";

export const componentTheme: ThemeConfig["components"] = {
    Button: { controlHeight: 40, borderRadius: RADIUS },
    Table: { borderRadius: RADIUS },
    Card: { borderRadiusLG: RADIUS, bodyPadding: 30 },
    Layout: {
        footerBg: BRAND.gray100,
        headerPadding: 28,
        headerHeight: HEADER_HEIGHT,
        colorFillContent: BRAND.white,
        headerBg: BRAND.white,
        siderBg: BRAND.white,
        footerPadding: 5,
    },
};
